import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/work", label: "Work" },
    { to: "/about", label: "About" },
    { to: "/awards", label: "Awards" },
    { to: "/contact", label: "Contact" },
];

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const loc = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [loc.pathname]);

    return (
        <header
            data-testid="site-nav"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-700 ${
                scrolled
                    ? "bg-black/60 backdrop-blur-xl border-b border-border"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-14 h-16 sm:h-20 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="group inline-flex items-center gap-3 font-serif-display text-lg sm:text-xl tracking-tight text-foreground"
                >
                    <span
                        aria-hidden
                        data-testid="nav-avatar"
                        className="relative inline-block w-8 h-8 sm:w-9 sm:h-9 rounded-full overflow-hidden bg-muted border border-border ring-1 ring-foreground/10 group-hover:ring-foreground/30 transition-all duration-500"
                    >
                        <img
                            src="https://customer-assets.emergentagent.com/job_director-portfolio-11/artifacts/xib0uo3r_IMG_6156.jpeg"
                            alt=""
                            className="w-full h-full object-cover"
                        />
                    </span>
                    <span>
                        John Alexander&nbsp;
                        <span className="text-muted-foreground">Jimenez</span>
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `text-label underline-anim ${
                                    isActive
                                        ? "text-foreground"
                                        : "text-muted-foreground hover:text-foreground"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <button
                    type="button"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-foreground p-2 -mr-2"
                >
                    {open ? <X size={20} strokeWidth={1.25} /> : <Menu size={20} strokeWidth={1.25} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden border-t border-border bg-black/90 backdrop-blur-xl"
                >
                    <div className="px-6 py-8 flex flex-col gap-6">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `font-serif-display text-3xl tracking-tight ${
                                        isActive
                                            ? "text-foreground"
                                            : "text-muted-foreground"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Nav;
